<template lang="html">
  <v-container fluid>
    <v-row class="primary white--text column-loyalty_point">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 white--text" @click="goBack()">mdi-arrow-left</v-icon>
          </span>
        </h2>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="d-flex align-center py-2">
          <div class="d-flex mr-3">
            <img src="@/assets/images/svg/loyalty_point.svg">
          </div>
          <div class="d-flex flex-column">
            <h2 class="display-1 font-weight-bold">
              {{ Number(user.join_loyalty_points) }}
            </h2>
            <h5 class="subtitle-2">
              Loyalty Point
            </h5>
          </div>
        </div>
        <div class="d-flex align-center py-2">
          <!-- <div v-if="user.fjoin_loyalty_points_money" class="d-flex">
            <div class="__text-price">
              {{ user.fjoin_loyalty_points_money }}
            </div>
          </div> -->
          <v-spacer />
          <div class="d-flex">
            <v-avatar size="80" class="avatar-border-loyalty_point">
              <img :src="user.photo_xs" alt="John">
            </v-avatar>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="loyalty.length > 0">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-list class="transactions-list">
          <v-list-item v-for="(item, idx) in loyalty" :key="idx">
            <v-list-item-avatar size="56" class="transaction_history_avatar">
              <v-img src="@/assets/images/svg/transaction_history.svg" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold primary--text">
                {{ item.order_no }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <span v-mask-money-only="item.total_amount" />
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-title class="font-weight-bold orange--text">
                + {{ Number(item.earned_points) }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption blue-grey--text text--lighten-4">
                points
              </v-list-item-subtitle>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="px-3 my-5">
          <div class="mx-auto d-flex justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="253.734" height="201.242" viewBox="0 0 253.734 201.242" class="no_data--img">
              <defs>
                <linearGradient id="a" x1="0.509" y1="0.997" x2="0.509" y2="-0.003" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="gray" stop-opacity="0.251" />
                  <stop offset="0.54" stop-color="gray" stop-opacity="0.122" />
                  <stop offset="1" stop-color="gray" stop-opacity="0.102" />
                </linearGradient>
                <linearGradient id="b" x1="0.813" y1="0.841" x2="0.813" y2="-0.159" xlink:href="#a" />
                <linearGradient id="c" x1="1.78" y1="0.849" x2="1.78" y2="-0.151" xlink:href="#a" />
                <linearGradient id="d" x1="0.5" y1="1" x2="0.5" y2="0" xlink:href="#a" />
                <linearGradient id="f" x1="0.5" y1="0.999" x2="0.5" y2="-0.001" xlink:href="#a" />
              </defs>
              <g transform="translate(37.488 32.609)">
                <path class="a" d="M236.861,41.749c8.609-7.663,22.122-9.233,34.423-8.623C309.919,35.047,344.793,53.7,374.96,74.8c10.922,7.636,21.674,15.868,28.761,26.386,14.441,21.411,10.15,51.072-9.914,68.71-6.829,6-15.1,10.61-23.6,14.68-15.107,7.25-31.408,13.071-48.555,14.736-12.225,1.179-24.6.221-36.76-1.426-33.96-4.615-67.29-14.8-95.238-32.224-12.254-7.642-23.8-17.144-28.856-29.5s-1.818-28.036,10.7-35.366c5.175-3.027,11.364-4.394,17.421-5.679,8.918-1.889,17.978-3.752,26.024-7.592,8.314-3.967,18.155-11.638,16.5-20.421C229.685,57.687,228.264,49.412,236.861,41.749Z" transform="translate(-196.003 -65.616)" />
                <rect class="b" width="94.384" height="130.408" transform="matrix(0.978, -0.21, 0.21, 0.978, 14.928, 29.262)" />
                <g class="c" transform="translate(16.951 11.952)">
                  <rect class="d" width="91.194" height="126" transform="matrix(0.978, -0.21, 0.21, 0.978, 0, 19.132)" />
                </g>
                <rect class="e" width="88.873" height="123.216" transform="matrix(0.978, -0.21, 0.21, 0.978, 18.28, 31.747)" />
                <rect class="f" width="44.089" height="10.68" transform="matrix(0.978, -0.21, 0.21, 0.978, 39.167, 21.802)" />
                <path class="g" d="M443.334,91.408a6.311,6.311,0,1,0,7.343,4.877A6.237,6.237,0,0,0,443.334,91.408Zm2.088,9.74a3.641,3.641,0,1,1,2.713-4.319,3.6,3.6,0,0,1-2.713,4.319Z" transform="translate(-384.803 -84.43)" />
                <rect class="h" width="43.16" height="10.209" transform="matrix(0.978, -0.21, 0.21, 0.978, 39.525, 21.256)" />
                <path class="h" d="M443.623,91.408a6.032,6.032,0,1,0,7.164,4.633A6.032,6.032,0,0,0,443.623,91.408Zm2,9.308a3.481,3.481,0,1,1,2.674-4.134A3.481,3.481,0,0,1,445.619,100.716Z" transform="translate(-385.092 -84.43)" />
                <rect class="b" width="94.384" height="130.408" transform="translate(55.697 25.249)" />
                <g class="c" transform="translate(57.293 27.454)">
                  <rect class="i" width="91.194" height="126" />
                </g>
                <rect class="j" width="88.873" height="123.216" transform="translate(58.453 28.383)" />
                <rect class="i" width="44.089" height="10.68" transform="translate(80.962 23.04)" />
                <path class="k" d="M644.484,118a6.312,6.312,0,1,0,6.164,6.311A6.239,6.239,0,0,0,644.484,118Zm0,9.952a3.641,3.641,0,1,1,3.555-3.641,3.6,3.6,0,0,1-3.555,3.624Z" transform="translate(-541.478 -105.385)" />
                <rect class="h" width="43.16" height="10.209" transform="translate(81.426 22.582)" />
                <path class="h" d="M644.962,118a6.032,6.032,0,1,0,6.032,6.032A6.032,6.032,0,0,0,644.962,118Zm0,9.514a3.5,3.5,0,1,0,0-.011Z" transform="translate(-541.956 -105.385)" />
                <g class="c" transform="translate(1.402 159.182)">
                  <rect class="l" width="0.812" height="4.607" transform="translate(1.896)" />
                  <rect class="l" width="0.812" height="4.607" transform="translate(4.607 1.898) rotate(90)" />
                </g>
                <g class="c" transform="translate(95.613)">
                  <rect class="l" width="0.812" height="4.607" transform="translate(1.896)" />
                  <rect class="l" width="0.812" height="4.607" transform="translate(4.607 1.896) rotate(90)" />
                </g>
                <path class="m" d="M948.919,825.463a1,1,0,0,1-.555-1.2.484.484,0,0,0,.022-.11h0a.5.5,0,0,0-.9-.33h0a.482.482,0,0,0-.056.1,1,1,0,0,1-1.2.555.48.48,0,0,0-.11-.022h0a.5.5,0,0,0-.33.9h0a.478.478,0,0,0,.1.056,1,1,0,0,1,.555,1.2.481.481,0,0,0-.022.11h0a.5.5,0,0,0,.9.33h0a.479.479,0,0,0,.056-.1,1,1,0,0,1,1.2-.555.484.484,0,0,0,.11.022h0a.5.5,0,0,0,.33-.9h0A.484.484,0,0,0,948.919,825.463Z" transform="translate(-782.387 -658.611)" />
                <path class="n" d="M314.509,620.4a1,1,0,0,1-.555-1.2.48.48,0,0,0,.022-.11h0a.5.5,0,0,0-.9-.33h0a.482.482,0,0,0-.056.1,1,1,0,0,1-1.2.555.48.48,0,0,0-.11-.022h0a.5.5,0,0,0-.33.9h0a.482.482,0,0,0,.1.056,1,1,0,0,1,.555,1.2.478.478,0,0,0-.022.11h0a.5.5,0,0,0,.9.33h0a.481.481,0,0,0,.056-.1,1,1,0,0,1,1.2-.555.48.48,0,0,0,.11.022h0a.5.5,0,0,0,.33-.9h0A.481.481,0,0,0,314.509,620.4Z" transform="translate(-284.992 -497.839)" />
                <path class="n" d="M842.919,121.083a1,1,0,0,1-.555-1.2.48.48,0,0,0,.022-.11h0a.5.5,0,0,0-.9-.33h0a.479.479,0,0,0-.056.1,1,1,0,0,1-1.2.555.479.479,0,0,0-.11-.022h0a.5.5,0,0,0-.33.9h0a.481.481,0,0,0,.1.056,1,1,0,0,1,.555,1.2.477.477,0,0,0-.022.11h0a.5.5,0,0,0,.9.33h0a.482.482,0,0,0,.056-.1,1,1,0,0,1,1.2-.555.479.479,0,0,0,.11.022h0a.5.5,0,0,0,.33-.9h0A.479.479,0,0,0,842.919,121.083Z" transform="translate(-699.28 -106.358)" />
                <circle class="o" cx="1.626" cy="1.626" r="1.626" transform="translate(173.881 66.291)" />
                <circle class="o" cx="1.626" cy="1.626" r="1.626" transform="translate(48.205 159.629)" />
                <circle class="o" cx="1.626" cy="1.626" r="1.626" transform="translate(157.18 101.442)" />
                <circle class="m" cx="1.626" cy="1.626" r="1.626" transform="translate(17.194 19.183)" />
                <circle class="p" cx="1.626" cy="1.626" r="1.626" transform="translate(0 63.546)" />
                <g transform="translate(25.067 -22.334) rotate(14)">
                  <g class="q" transform="translate(72.482 77.912)">
                    <rect class="s" width="62" height="26" />
                    <rect class="t" x="0.5" y="0.5" width="61" height="25" />
                  </g>
                  <text class="r" transform="translate(103.482 96.912)">
                    <tspan x="-25.578" y="0">
                      EMPTY
                    </tspan>
                  </text>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  getData as getDataCustomer,
  getDataPoint as getDataLoyaltyPoint
} from '@/api/customer'
export default {
  data() {
    return {
      loyalty: [],
      user: {}
    }
  },
  created() {
    this.loadLoyalty()
    this.loadCustomer()
  },
  methods: {
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    async loadLoyalty() {
      try {
        const { data } = await getDataLoyaltyPoint()
        this.$store.state.loading_axios = false
        this.loyalty = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async loadCustomer() {
      try {
        const { data } = await getDataCustomer()
        this.$store.state.loading_axios = false
        this.user = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
